import { Message } from '@backend/domain'
import { MessageResponse } from '../types'

export class MessageMapper {
	static toResponse(message: Message): MessageResponse {
		return {
			id: message.id,
			body: message.body,
			type: message.type,
			acknowledged: message.acknowledged,
		}
	}
}
